import { FormattedMessage } from 'react-intl'
import { IClass } from '@/interfaces/general'
import Button from '@/components/Primitive/Buttons/Button/Button'
import { isIOSApp, reloadPageOnIOS } from '@/utils/app'
import styles from './RebootPanel.module.scss'
import classNames from 'classnames'
import { useState } from 'react'

type RebootModalProps = IClass

const RebootPanel = ({ className }: RebootModalProps) => {
  const [blockBtn, setBlockBtn] = useState(false)

  const reloadHandler = () => {
    setBlockBtn(true)
    if (isIOSApp()) {
      reloadPageOnIOS()
    } else {
      window.location.reload()
    }
  }

  return <div className={classNames(styles.contextBox, className)}>
    <FormattedMessage id="reload_page_description">
      {txt => <p className={styles.description}>{txt}</p>}
    </FormattedMessage>
    <FormattedMessage id="reload">
      {txt => <Button
        className={styles.btn}
        disabled={blockBtn}
        onClick={reloadHandler}
      >
        {txt}
      </Button>}
    </FormattedMessage>
  </div>
}

export default RebootPanel
